import React from 'react';
import { object } from 'prop-types';
import { CarouselLink } from '../CarouselLink';

import './style.scss';

export const CarouselFooter = ({ showMore, dataEnrichment }) => {
    if (!showMore) {
        return null;
    }

    return (
        <section className="carousel-footer">
            <CarouselLink urlData={showMore} dataEnrichment={dataEnrichment} showMore />
        </section>
    );
};

CarouselFooter.propTypes = {
    showMore: object,
    dataEnrichment: object,
};
